import { render } from "./ThumbnailsContent.vue?vue&type=template&id=4b9dbf2b"
import script from "./ThumbnailsContent.vue?vue&type=script&lang=js"
export * from "./ThumbnailsContent.vue?vue&type=script&lang=js"

import "./ThumbnailsContent.vue?vue&type=style&index=0&id=4b9dbf2b&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__